import * as React from 'react';
import { css } from "@emotion/core";
import { localeTextGetter } from '../../utils/l10n';
import { StaticQuery, graphql } from 'gatsby';

const SearchNotFound = props => {
  return (
    <StaticQuery
      query={graphql`
        query notFoundSearchQuery {
          sanityAsset {
            homePage {
              trainers {
                icons {
                  name
                  image {
                    asset {
                      url
                    }
                  }
                }
              }
            }
          }
          sanityNotFound {
            result {
              _type
              en
              es
            }
            text {
              _type
              en
              es
            }
          }
        }
      `}
      render={data => {
        const { sanityAsset, sanityNotFound } = localeTextGetter(data);

        return (
          <div
            css={css`
              width: 80%;
              height: 92px;
              margin-top: 20px;
              border: solid 1px rgba(149, 151, 154, 0.47);
              box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
              border-radius: 8px;
              position: relative;
              display: flex;
              text-align: left;
            `}
          >
            <div
              onClick={() => props.resetSearch()}
              css={css`
                position: absolute;
                top: 5px;
                right: 10px;
              `}
            >
              <img
                src={sanityAsset.homePage.trainers.icons[8].image.asset.url}
              />
            </div>

            <div
              css={css`
                margin-top: auto;
                margin-bottom: auto;
                margin-left: 20px;
                @media (min-width: 600px) {
                  margin-left: 80px;
                }
              `}
            >
              <p>{sanityNotFound.result}</p>
              <p>{sanityNotFound.text}</p>
            </div>
          </div>
        );
      }}
    />
  );
};

export default SearchNotFound;
